import { render } from "./BetaProfileProjectCard.vue?vue&type=template&id=62069ebe&scoped=true"
import script from "./BetaProfileProjectCard.vue?vue&type=script&lang=js"
export * from "./BetaProfileProjectCard.vue?vue&type=script&lang=js"

import "./BetaProfileProjectCard.vue?vue&type=style&index=0&id=62069ebe&scoped=true&lang=css"
import "./BetaProfileProjectCard.vue?vue&type=style&index=1&id=62069ebe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62069ebe"]])

export default __exports__